Ember.Handlebars.registerBoundHelper('emailLink', function(value) {
    value = Ember.Handlebars.Utils.escapeExpression(value)
    return ('<a href="mailto:"' + value + '" class="link">' + value + '</a>').htmlSafe()
})
